import moment from "moment";
import React, { useEffect } from "react";
import { AuthenticationState } from "react-aad-msal";
import { Col, Container, Row } from "react-bootstrap";
import { capitalizeObjEntries } from "../../util";
import PegModule from "../loyalty/PegModule";
import Card from "./Card";

var CurrentOrder = function CurrentOrder(props) {
  var order = props.order,
      _props$returnAction = props.returnAction,
      _returnAction = _props$returnAction === void 0 ? function () {
    return "";
  } : _props$returnAction,
      _props$topAction = props.topAction,
      topAction = _props$topAction === void 0 ? function () {
    return "";
  } : _props$topAction,
      fields = props.fields,
      topOfPageRef = props.topOfPageRef;

  var FormatedDate = moment(order.transactionDate).format("dddd, MMMM D, YYYY");
  var title = "$".concat(order.transactionTotal, " | Order # ").concat(order.mappedOrderNumber, " | ").concat(order.handOffType);
  var items = order.orderItems;

  var actionForLineItem = function actionForLineItem(lineId) {
    topAction(order.id, lineId);
  };

  useEffect(function () {
    if (topOfPageRef.current) {
      topOfPageRef.current.scrollIntoView();
    }
  }, [order]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "cb-account-order__container--info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, FormatedDate)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title cb-account-order__top-title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__callout"
  }, order.orderStoreLocation)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Subtotal")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value"
  }, "$", order.transactionSubtotal))), order.rewardRedeemedOnOrder && order.transactionSavings ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__rewards-callout"
  }, "Rewards Redeemed")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value cb-account-order__rewards-callout"
  }, "-$", order.transactionSavings))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Collected tax")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value"
  }, "$", order.transactionTax))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Tip")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value"
  }, "$", order.transactionTip))), order.transactionGiftCardTotal && order.transactionGiftCardTotal > 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Gift Card:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "$", order.transactionGiftCardTotal))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Row, {
    className: "cb-account-order__total-container"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__total"
  }, "Total")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value cb-account-order__total"
  }, "$", order.transactionTotal))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(PegModule, {
    store: props === null || props === void 0 ? void 0 : props.store,
    authenticationState: AuthenticationState.Authenticated,
    orderId: order.id,
    earnedPegs: order === null || order === void 0 ? void 0 : order.rewardsPointsEarned,
    orderSubTotal: (order === null || order === void 0 ? void 0 : order.transactionSubtotal) - (order === null || order === void 0 ? void 0 : order.transactionSavings),
    fields: (fields === null || fields === void 0 ? void 0 : fields.PegModule) && (fields === null || fields === void 0 ? void 0 : fields.PegModule.length) >= 1 ? fields.PegModule[0].fields : {}
  })))), /*#__PURE__*/React.createElement(Col, null, items && /*#__PURE__*/React.createElement(Container, {
    className: "cb-account-order__product-list"
  }, items.map(function (item, index) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(Row, {
      key: "cart-item-".concat(index),
      className: "cb-account-order__divider"
    }, /*#__PURE__*/React.createElement(Col, {
      key: "cart-item-".concat(index)
    }, /*#__PURE__*/React.createElement(Card, {
      item: Item,
      full: true,
      topAction: function topAction(e) {
        actionForLineItem(Item.Id);
      },
      returnAction: function returnAction(e) {
        e.orderNumber = order.orderNumber;

        _returnAction(e);
      }
    })));
  })))))));
};

export default CurrentOrder;